import React, { useState } from 'react'
import { useStyles } from '../FlyOutUsageMetering.styles'
import { ButtonV2, SidePanelInfo } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'

import { qAndAHelpData } from '../../../common/utils/qAndAHelpData'
import { QAndASidePannel } from './QAndASidePannel'

export const MeteringHelpContainer: React.FC = () => {
  const { classes } = useStyles()

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const openDrawer = () => {
    setIsOpen(true)
  }
  const toggleDrawer = async () => {
    setIsOpen(false)
  }

  return (
    <>
      <div className={classes.helpContainer}>
        <ButtonV2
          key={'usage-metering-help-drawer'}
          styleType="link"
          data-testid="metering-help-button-drawer"
          icon={
            <FontAwesomeIcon icon={faCircleInfo} className={classes.infoIcon} />
          }
          onClick={openDrawer}
        >
          Help & FAQs
        </ButtonV2>
      </div>
      <SidePanelInfo
        icon={
          <FontAwesomeIcon
            icon={faCircleInfo}
            className={classes.sidePanelInfoIcon}
          />
        }
        headerTitle={
          <div className={classes.sidePanelTitleText}>Help and FAQs</div>
        }
        open={isOpen}
        onClose={toggleDrawer}
        content={
          <div className={classes.qAndAParentWrapper}>
            <QAndASidePannel content={qAndAHelpData.content} />
          </div>
        }
      />
    </>
  )
}
